import { AxiosResponse } from "axios"
import { apiInstance } from "../base"
import { ICreateBillingRequest, ICreateOrder, IDebitRequest, IEarnRequest, IGetPairChartResults, IGetTradingPartnersResults, IListTransactionsResults, IPairGlass, ITradingBilling, ITradingPair, ITradingPartner, ITradingWalletBalance } from "./types"

export const listPairs = (): Promise<AxiosResponse<{data: ITradingPair[]}>> => {
    return apiInstance.handler.get<{data: ITradingPair[]}>(`/trading/pairs`)
}

export const getPairGlass = (pair_id: string): Promise<AxiosResponse<{ data: IPairGlass }>> => {
    return apiInstance.handler.get<{ data: IPairGlass }>(`/trading/pairs/${pair_id}/glass`)
}

export const getTransactions = (count: number, cursor: number, startDate: Date, endDate: Date, counterpartyId: string[] | null, destType: string[] | null): Promise<AxiosResponse<IListTransactionsResults>> => {
    return apiInstance.handler.get<IListTransactionsResults>(`/trading/transactions`, {
        params: {
            count,
            cursor,
            startDate,
            endDate,
            counterpartyId,
            destType
        }
    })
}

export const getPair = (pair_id: string): Promise<AxiosResponse<{ data: ITradingPair }>> => {
    return apiInstance.handler.get<{ data: ITradingPair }>(`/trading/pairs/${pair_id}`)
}

export const getPairChart = (pair_id: string, count: number, interval: number, cursor?: number): Promise<AxiosResponse<IGetPairChartResults>> => {
    return apiInstance.handler.get<IGetPairChartResults>(`/trading/pairs/${pair_id}/chart`, {
        params: {
            count,
            cursor,
            interval
        }
    })
}

export const createOrder = (data: ICreateOrder): Promise<AxiosResponse<void>> => {
    return apiInstance.handler.post<void>(`/trading/orders`, data)
}

export const getTradingWalletBalance = (): Promise<AxiosResponse<{data: ITradingWalletBalance}>> => {
    return apiInstance.handler.get<{data: ITradingWalletBalance}>(`/trading/bonuses/balance`)
}

export const createEarnApplication = (dto: IEarnRequest): Promise<AxiosResponse<void>> => {
    return apiInstance.handler.post<void>(`/trading/bonuses/earn`, dto)
}

export const createBilling = (dto: ICreateBillingRequest): Promise<AxiosResponse<ITradingBilling>> => {
    return apiInstance.handler.post<ITradingBilling>(`/trading/billings`, dto)
}

export const getBillingPdf = (id: number): Promise<AxiosResponse> => {
    return apiInstance.handler.get(`/trading/billings/${id}`, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/pdf',
        },
    })
}

export const debit = (dto: IDebitRequest): Promise<AxiosResponse<void>> => {
    return apiInstance.handler.post<void>(`/trading/bonuses/debit`, dto)
}

export const getTradingPartners = (searchQuery: string | null, type?: "foundation" | "partner"): Promise<AxiosResponse<IGetTradingPartnersResults>> => {
    return apiInstance.handler.get<IGetTradingPartnersResults>(`/social-market-partners`, {
        params: {
            search: searchQuery,
            type
        }
    })
}

export const getTradingPartner = (id: string): Promise<AxiosResponse<ITradingPartner>> => {
    return apiInstance.handler.get<ITradingPartner>(`/social-market-partners/${id}`)
}
